import type { FilterDropdownOption } from '@/shared/ui/FilterDropdown';

export const getDagTagOptions = (dagTags: string[][]): FilterDropdownOption<string>[] => {
  if (!Array.isArray(dagTags)) return [];

  const uniqueTags = new Set<string>();
  for (const tags of dagTags) {
    if (!tags) continue;
    for (const tag of tags) {
      const trimmed = tag.trim();
      if (trimmed.length > 0) {
        uniqueTags.add(trimmed);
      }
    }
  }

  const sortedUniqueTags = Array.from(uniqueTags).sort((left, right) => left.localeCompare(right));
  const options = sortedUniqueTags.map((tag) => ({
    key: tag,
    label: tag,
    value: tag,
  }));

  return options;
};
